import React from 'react';
import PropTypes from 'prop-types';
import { getClassName } from '../../../utils/ui/classes';
import CargomaticTooltip from '../Tooltip';
import ErrorLabel from './ErrorLabel';

const Radio = ({
  id,
  name,
  value,
  label,
  children,
  checked,
  helptext,
  onChange,
  disabled,
  className,
  error,
  style,
  hideLabel,
  info,
}) => {
  function handleChange(e) {
    onChange(e.target.value);
  }

  let body;

  if (label) {
    body = label;
  } else if (children) {
    body = children;
  }

  function renderErrorMessage() {
    if (!(error && error.message)) {
      return null;
    }
    return <ErrorLabel className="mt-1 mb-4">{error.message}</ErrorLabel>;
  }

  const hasLabel = !hideLabel && body;
  const containerClassName = getClassName('relative', className);

  // Wrapping the input inside the <label> makes clicking the text toggle the
  // control natively — no htmlFor/id association (which breaks when ids collide
  // across the page).
  const labelWrapperClassName = getClassName('relative flex items-start', {
    'cursor-pointer': !disabled,
    'cursor-not-allowed': disabled,
  });

  const labelTextClassName = getClassName({
    'ml-3': hasLabel,
    'text-sm': hasLabel,
  });

  return (
    <div className={containerClassName} style={style}>
      <label className={labelWrapperClassName}>
        <span className="flex items-center h-5">
          <input
            id={id}
            type="radio"
            name={name}
            value={value}
            checked={checked}
            disabled={disabled}
            onChange={handleChange}
            className="w-4 h-4 border-gray-200 border-solid rounded text-green focus:ring-green"
          />
        </span>
        {hasLabel && (
          <span className={labelTextClassName}>
            <span className="flex items-center font-medium text-gray-700">
              {body}
              {info && (
                <CargomaticTooltip id={info} className="ml-1">
                  {info}
                </CargomaticTooltip>
              )}
            </span>
          </span>
        )}
      </label>
      {helptext && <div className="mt-1 ml-7 text-sm">{helptext()}</div>}
      {renderErrorMessage()}
    </div>
  );
};

Radio.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  hideLabel: PropTypes.bool,
  label: PropTypes.string,
  children: PropTypes.any,
  helptext: PropTypes.func,
  info: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
  style: PropTypes.object,
  error: PropTypes.object,
};

Radio.defaultProps = {
  hideLabel: false,
  checked: false,
  disabled: false,
  error: {},
};

export default Radio;
